import { render } from "./Credits.vue?vue&type=template&id=852c0e1e&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=852c0e1e&lang=scss&scoped=true"

import exportComponent from "/Users/danny/Documents/projects/camden-mobile/microsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852c0e1e"]])

export default __exports__